import { Container } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useParams } from "react-router"

interface IssueData {
  id: string;
  name: string;
  description: string;
}

const IssuesPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const testData: Array<IssueData> = [
    {
      id: "001",
      name: "Issue Name",
      description: "Issue Description"
    },
    {
      id: "002",
      name: "Other Issue Name",
      description: "Other Issue Description"
    }
    ,
    {
      id: "003",
      name: "Other More Different Issue Name",
      description: "Other More Different Issue Description"
    }
  ]

  const columns: GridColDef[] = [
    {
      field: 'id',
      headerName: 'Issue ID',
      flex: 1,
      renderCell: (params) => {
        return (
          <span>
            {params.value}
          </span>
        )
      }
    },
    {
      field: 'name',
      headerName: 'Issue Name',
      flex: 1,
      renderCell: (params) => {
        return (
          <span>
            {params.value}
          </span>
        )
      }
    }, {
      field: 'description',
      headerName: 'Issue Description',
      flex: 1,
      renderCell: (params) => {
        return (
          <span>
            {params.value}
          </span>
        )
      }
    },
  ];

  return (
    <Container>
      <DataGrid
        columns={columns}
        rows={testData}
      />
    </Container>
  );
}

export default IssuesPage;
